(function () {
  if (window.CartRewardsBarAnimator) return;
  window.CartRewardsBarAnimator = true;

  var SPEED = 7; // ms per percentage point (full sweep ~700ms)
  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var store = {}; // remembers the last fill % per segment across re-renders
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function sum(a) { var t = 0; for (var i = 0; i < a.length; i++) t += a[i]; return t; }

  function animateBar(bar) {
    var fills = Array.prototype.slice.call(bar.querySelectorAll('[data-fill-target]'));
    if (!fills.length) return;

    // Distinct memory per bar location (drawer / notification / page)
    var key = bar.closest('cart-drawer') ? 'd' : (bar.closest('cart-notification') ? 'n' : 'p');
    key += '-' + (bar.className.indexOf('--segmented') > -1 ? 's' : 'o');

    var targets = fills.map(function (el) { return parseFloat(el.getAttribute('data-fill-target')) || 0; });
    var prevs = fills.map(function (el, i) { var k = key + i; return (k in store) ? store[k] : 0; });

    // Skip entirely if nothing changed (avoids killing an in-flight animation)
    var changed = false;
    for (var i = 0; i < fills.length; i++) { if (Math.abs(targets[i] - prevs[i]) > 0.5) changed = true; }
    if (!changed) return;

    if (reduce.matches) {
      fills.forEach(function (el, i) {
        el.style.transition = 'none';
        el.style.width = targets[i] + '%';
        store[key + i] = targets[i];
      });
      return;
    }

    // Stagger so the fill flows continuously across segments.
    // Increasing: segment 1 then segment 2. Decreasing: reverse.
    var order = [];
    for (var j = 0; j < fills.length; j++) order.push(j);
    if (sum(targets) < sum(prevs)) order.reverse();

    var cum = 0, dur = [], del = [];
    order.forEach(function (idx) {
      var d = Math.abs(targets[idx] - prevs[idx]) * SPEED;
      del[idx] = cum;
      dur[idx] = d;
      cum += d;
    });

    fills.forEach(function (el, i) {
      el.style.transition = 'none';
      el.style.width = prevs[i] + '%';
      void el.offsetWidth; // force reflow so the start value sticks
      el.style.transition = 'width ' + Math.round(dur[i]) + 'ms ' + EASE + ' ' + Math.round(del[i]) + 'ms';
      el.style.width = targets[i] + '%';
      store[key + i] = targets[i];
    });
  }

  function animateAll() {
    var bars = document.querySelectorAll('.free-shipping-bar');
    for (var i = 0; i < bars.length; i++) animateBar(bars[i]);
  }

  function init() {
    animateAll();
    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(function () { scheduled = false; animateAll(); });
    }
    var obs = new MutationObserver(schedule);
    ['cart-drawer', 'cart-items', 'cart-notification'].forEach(function (sel) {
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) obs.observe(nodes[i], { childList: true, subtree: true });
    });
    document.addEventListener('shopify:section:load', schedule);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
